import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useVendors = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadVendors();
  }, []);

  const loadVendors = async () => {
    try {
      setLoading(true);
      setError(null);

      const { data, error: fetchError } = await supabase
        .from('vendors')
        .select('*')
        .order('priority', { ascending: true, nullsFirst: false })
        .order('created_at', { ascending: false });

      if (fetchError) {
        console.error('Error loading vendors:', fetchError);
        setError(fetchError.message);
        setVendors([]);
      } else {
        setVendors(data || []);
      }
    } catch (err) {
      console.error('Error loading vendors:', err);
      setError(err.message);
      setVendors([]);
    } finally {
      setLoading(false);
    }
  };

  return { vendors, loading, error, refreshVendors: loadVendors };
};

